const normalizeString = (value) => String(value == null ? '' : value).trim();

export const CHAT_ROW_SIDE = Object.freeze({
  left: 'admin',
  right: 'artist',
});

export const CHAT_BUBBLE_TONE = Object.freeze({
  left: 'admin-message',
  right: 'artist-message',
  announcement: 'admin-message note-card',
});

export const normalizeChatAdminSenderId = (message = {}) =>
  normalizeString(
    message.admin_user_id ??
      message.adminUserId ??
      message.sender_admin_user_id ??
      message.senderAdminUserId ??
      ''
  );

export const isSameChatActorId = (left, right) => {
  const normalizedLeft = normalizeString(left);
  const normalizedRight = normalizeString(right);
  return Boolean(normalizedLeft && normalizedRight && normalizedLeft === normalizedRight);
};

export const isAdminChatMessage = (message = {}) =>
  message.message_type === 'admin_message' ||
  normalizeString(message.sender_type).toLowerCase() === 'admin' ||
  Boolean(message.admin_user_id);

export const isOwnAdminChatMessage = (message = {}, currentAdminId = '') =>
  isAdminChatMessage(message) && isSameChatActorId(normalizeChatAdminSenderId(message), currentAdminId);

export function buildAdminIndividualMessagePresentation({
  message,
  currentAdminId = '',
  isSystemMessage = false,
  artistName = '',
  resolveAdminName,
}) {
  const isAdminMessage = isAdminChatMessage(message);
  const adminSenderName =
    isAdminMessage && typeof resolveAdminName === 'function'
      ? normalizeString(resolveAdminName(message))
      : '';
  const isOwnStandardMessage = isOwnAdminChatMessage(message, currentAdminId) && !isSystemMessage;
  const leftSenderName = isOwnStandardMessage || isSystemMessage
    ? ''
    : isAdminMessage
      ? adminSenderName
      : (normalizeString(artistName || message?.artist_name) || 'アーティスト');

  return {
    isAdminMessage,
    isOwnStandardMessage,
    isSelfRow: isOwnStandardMessage,
    adminSenderName,
    leftSenderName,
    showSender: Boolean(leftSenderName),
  };
}

export function resolveAdminIndividualBubbleClassName({
  className = '',
  isOwnStandardMessage = false,
  isSystemMessage = false,
} = {}) {
  const rawClassName = normalizeString(className);
  if (isSystemMessage) return rawClassName;
  const toneClassName = isOwnStandardMessage ? 'admin-message' : 'artist-message';
  const rest = rawClassName
    .split(/\s+/)
    .filter((entry) => entry && entry !== 'admin-message' && entry !== 'artist-message')
    .join(' ');
  return [toneClassName, rest].filter(Boolean).join(' ');
}

export function buildArtistIndividualMessagePresentation({
  message,
  isSystemMessage = false,
  resolveAdminName,
}) {
  const isAdminMessage = isAdminChatMessage(message);
  const adminSenderName =
    isAdminMessage && !isSystemMessage && typeof resolveAdminName === 'function'
      ? normalizeString(resolveAdminName(message))
      : '';

  return {
    isAdminMessage,
    isSelfRow: !isAdminMessage,
    adminSenderName,
    leftSenderName: adminSenderName,
    showSender: Boolean(adminSenderName),
  };
}
